import { render, staticRenderFns } from "./SkuDetail.vue?vue&type=template&id=552c292a&scoped=true&"
import script from "./SkuDetail.vue?vue&type=script&lang=js&"
export * from "./SkuDetail.vue?vue&type=script&lang=js&"
import style0 from "./SkuDetail.vue?vue&type=style&index=0&id=552c292a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c292a",
  null
  
)

export default component.exports